import { useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link as RouterDomLink, useNavigate } from 'react-router-dom';

import CartItem from "./CartItem";
import CartSummary from "./CartSummary";
import CartPromotionDialog from "./CartPromotionDialog";
import AlertOrderNoCompleted from "../Checkout/AlertOrderNoCompleted/AlertOrderNoCompleted";

import { NavContext } from "../../../context/NavContext";

import { shopCoupons } from "../../../actions/shop";

import img from '../../../assets/resources/Carrito_compras_nefrópolis.png';

//Swiper
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation } from "swiper";
// import 'swiper/css';
// import "swiper/css/navigation";

//CSS
import './cart.css';
// import './OpenPayForm.css';

//MUI
import {
    Typography, Container, Button, Grid, LinearProgress, Breadcrumbs,
    Box, Stack, Divider, useMediaQuery
} from "@mui/material";
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import { styled } from '@mui/material/styles';

const CustomButton = styled(Button)({
    backgroundColor: '#38B6FF',
    '&:hover': {
        backgroundColor: '#1FA3F0 '
    }
});

const CartComponent = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { setValue } = useContext(NavContext);

    const matches = useMediaQuery('(max-width: 950px)');

    // bandera [carga de productos]
    const { loading: { shop_products } } = useSelector(state => state.ui);

    const {
        cart: {
            item, // productos de carrito
            cart_promotion, // promociones disponibles
            checkout: { skip } // pedido pendiente
        }
    } = useSelector(state => state.shop);

    useEffect(() => {
        // cargar lista de cupones
        dispatch(shopCoupons());
    }, []);

    // dirigirse a página de variante
    const goToProductPage = (url, barcode) => () => {
        navigate(`/tienda/producto/${url}/${barcode}`);
    };

    const my_style = matches ? { my: 6 } : { mt: 18, mb: 6 };

    return (
        shop_products ? (
            <Container maxWidth="xl" sx={{ width: '100%', ...my_style }}>
                <Typography variant="h6" sx={{ mb: 1 }}>
                    Cargando tu carrito, por favor espera...
                </Typography>
                <LinearProgress />
            </Container>
        ) : (
            item.length > 0 ?
                <Container maxWidth='xl' sx={{ mt: matches ? 5 : 18 }} className="last-view">
                    {/* Cart header */}
                    <Typography variant="h4" sx={{ fontWeight: 'light' }} gutterBottom>Carrito de compras</Typography>
                    <Breadcrumbs aria-label="breadcrumb">
                        <RouterDomLink to='/' style={{ textDecoration: 'none' }}>
                            Inicio
                        </RouterDomLink>
                        <RouterDomLink to='/tienda' style={{ textDecoration: 'none' }}>
                            Tienda
                        </RouterDomLink>
                        <Typography color="text.primary">Carrito de compras</Typography>
                    </Breadcrumbs>

                    {/* Alerta de pedido no completado */}
                    <Box sx={{ mt: 3 }}>
                        <AlertOrderNoCompleted />
                    </Box>

                    <CartPromotionDialog
                        cart_promotion={cart_promotion}
                        goToProductPage={goToProductPage}
                    />

                    {/* Row */}
                    <Grid container spacing={4} sx={{ mt: 0 }}>
                        {/* Productos en carrito */}
                        <CartItem
                            goToProductPage={goToProductPage}
                        />
                        {/* Fin productos en carrito */}

                        {/* Total */}
                        <CartSummary />
                        {/* Fin Total del carrito */}
                    </Grid>
                    {/* Fin row */}

                </Container>
                :
                <Container maxWidth="xl" sx={{ mt: matches ? 5 : 18, textAlign: 'center' }} className="last-view">
                    <img src={img} width="15%" alt={img} />
                    <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
                        ¡Tu carrito está actualmente vacío!
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        {/* Antes de finalizar su compra debe añadir algunos productos al carrito de compras. <br />
                        Encontrará muchos productos interesantes en nuestra página de tienda. */}
                        Visita nuestra tienda y descubre muchos productos interesantes. ¡No te pierdas nuestras ofertas!
                    </Typography>

                    {
                        skip &&
                            <>
                                <Divider />
                                <Box>
                                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
                                        ¡Tienes un pedido pendiente! Puedes continuar desde donde lo dejaste.
                                    </Typography>
                                    <ReceiptOutlinedIcon sx={{ color: '#38B6FF', fontSize: 80 }} />
                                </Box>
                            </>
                    }
                    

                    <Stack direction="row"
                        spacing={2} sx={{
                            justifyContent: "center",
                            alignItems: "center",
                        }}>
                        {
                            skip &&
                                <RouterDomLink to="/checkout-resumen" style={{ textDecoration: 'none' }}>
                                    <CustomButton variant="contained" sx={{ mt: 1 }}
                                        onClick={() => { setValue('/tienda') }}>
                                        Revisar mi pedido
                                    </CustomButton>
                                </RouterDomLink>
                        }
                        <RouterDomLink to="/tienda" style={{ textDecoration: 'none' }}>
                            <Button variant="contained" sx={{ mt: 1 }} onClick={() => { setValue('/tienda') }}>
                                Regresar a la tienda
                            </Button>
                        </RouterDomLink>
                    </Stack>
                </Container>
        )
    );
};

export default CartComponent;